import { Col, Form, Row } from "react-bootstrap";
import { formLabelTranslations, tbo } from "./translation";

export default function({ prefix, formik, language }: { prefix: string; formik: any, language: string }) {
  const onChange = (event: React.ChangeEvent<any>) : void => {
    const { name, value } = event.target;
    const fieldName = name.split(".")[1];
    const key = `${prefix}_${fieldName}`;
    localStorage.setItem(key, JSON.stringify(value));
    formik.handleChange(event);
  };
  return (
    <>
      <Form.Group className="mb-1" as={Row}>
        <Form.Label column sm={3}>{tbo(language, formLabelTranslations.addressCompanyName)}</Form.Label>
        <Col sm={9}>
          <Form.Control
            name={`${prefix}.companyName`}
            type="text"
            value={formik.values[prefix].companyName}
            onChange={onChange}
            onBlur={formik.handleBlur}
            isInvalid={
              formik.touched[prefix]?.companyName &&
              Boolean(formik.errors[prefix]?.companyName)
            }
          />
          <Form.Control.Feedback type="invalid">
            {formik.errors[prefix]?.companyName}
          </Form.Control.Feedback>
        </Col>
      </Form.Group>

      <Form.Group className="mb-1" as={Row}>
        <Form.Label column sm={3}>{tbo(language, formLabelTranslations.addressStreetNumber)}</Form.Label>
        <Col sm={9}>
          <Form.Control
            name={`${prefix}.streetNumber`}
            type="text"
            value={formik.values[prefix].streetNumber}
            onChange={onChange}
            onBlur={formik.handleBlur}
            isInvalid={
              formik.touched[prefix]?.streetNumber &&
              Boolean(formik.errors[prefix]?.streetNumber)
            }
          />
          <Form.Control.Feedback type="invalid">
            {formik.errors[prefix]?.streetNumber}
          </Form.Control.Feedback>
        </Col>
      </Form.Group>

      <Form.Group className="mb-1" as={Row}>
        <Form.Label column sm={3}>{tbo(language, formLabelTranslations.addressPostalCode)}</Form.Label>
        <Col sm={9}>
          <Form.Control
            name={`${prefix}.postalCode`}
            type="text"
            value={formik.values[prefix].postalCode}
            onChange={onChange}
            onBlur={formik.handleBlur}
            isInvalid={
              formik.touched[prefix]?.postalCode &&
              Boolean(formik.errors[prefix]?.postalCode)
            }
          />
          <Form.Control.Feedback type="invalid">
            {formik.errors[prefix]?.postalCode}
          </Form.Control.Feedback>
        </Col>
      </Form.Group>

      <Form.Group className="mb-1" as={Row}>
        <Form.Label column sm={3}>{tbo(language, formLabelTranslations.addressCity)}</Form.Label>
        <Col sm={9}>
          <Form.Control
            name={`${prefix}.city`}
            type="text"
            value={formik.values[prefix].city}
            onChange={onChange}
            onBlur={formik.handleBlur}
            isInvalid={
              formik.touched[prefix]?.city &&
              Boolean(formik.errors[prefix]?.city)
            }
          />
          <Form.Control.Feedback type="invalid">
            {formik.errors[prefix]?.city}
          </Form.Control.Feedback>
        </Col>
      </Form.Group>

      <Form.Group className="mb-1" as={Row}>
        <Form.Label column sm={3}>{tbo(language, formLabelTranslations.addressContactPerson)}</Form.Label>
        <Col sm={9}>
          <Form.Control
            name={`${prefix}.contactPerson`}
            type="text"
            value={formik.values[prefix].contactPerson}
            onChange={onChange}
            onBlur={formik.handleBlur}
            isInvalid={
              formik.touched[prefix]?.contactPerson &&
              Boolean(formik.errors[prefix]?.contactPerson)
            }
          />
          <Form.Control.Feedback type="invalid">
            {formik.errors[prefix]?.contactPerson}
          </Form.Control.Feedback>
        </Col>
      </Form.Group>

      <Form.Group className="mb-1" as={Row}>
        <Form.Label column sm={3}>{tbo(language, formLabelTranslations.addressPhone)}</Form.Label>
        <Col sm={9}>
          <Form.Control
            name={`${prefix}.phone`}
            type="text"
            value={formik.values[prefix].phone}
            onChange={onChange}
            onBlur={formik.handleBlur}
            isInvalid={
              formik.touched[prefix]?.phone &&
              Boolean(formik.errors[prefix]?.phone)
            }
          />
          <Form.Control.Feedback type="invalid">
            {formik.errors[prefix]?.phone}
          </Form.Control.Feedback>
        </Col>
      </Form.Group>

      <Form.Group className="mb-1" as={Row}>
        <Form.Label column sm={3}>{tbo(language, formLabelTranslations.addressEmail)}</Form.Label>
        <Col sm={9}>
          <Form.Control
            name={`${prefix}.email`}
            type="text"
            value={formik.values[prefix].email}
            onChange={onChange}
            onBlur={formik.handleBlur}
            isInvalid={
              formik.touched[prefix]?.email &&
              Boolean(formik.errors[prefix]?.email)
            }
          />
          <Form.Control.Feedback type="invalid">
            {formik.errors[prefix]?.email}
          </Form.Control.Feedback>
        </Col>
      </Form.Group>
    </>
  )
}